import { Component, OnInit, HostListener, ViewChild, EventEmitter, AfterViewInit, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { APP_RESOLVER_PROVIDERS } from "./../app.resolver";
import { ClearanceItem, ListSearchData, MassUpdateData } from './index';
import { ILookup, LookupList } from '../shared/lookup';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppService } from '../app.service';
import { DatePipe, Location, LocationStrategy, isPlatformBrowser, PlatformLocation } from "@angular/common"
import { CIImage, ClearanceItemTagComponent } from './index';
import { ClearanceItemService } from './clearance-item.service';
import { ComponentCanDeactivate, MessageBrokerService, AuthService } from '../shared/core/index';
import { NotificationsService, Notification } from '../shared/helper-components/index'
import { MaterializeAction } from 'angular2-materialize';
import { ClearanceItemAssetManagerComponent } from './asset-management/clearance-item-asset-manager.component';
import * as $ from 'jquery';
import { CIDocument, CITag, CIAsset } from './clearance-item.model';
import { SharedUtils, DateUtils } from '../shared/utils';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { ProjectItem } from '../project';
import { ReportsService } from '../reports/reports.service';
import { ReportBuilder } from '../reports/reports-builder.model';
import { ClearanceItemBulkComponent } from './bulk-action/clearance-item-bulk.component';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { ModalService } from '../shared/helper-components/modal/_services/modal.service';
import { ProjectService } from '../project/project.service';
import { IProject } from '../project/project.model';

declare var Materialize: any;

@Component({
    selector: 'clearance-list',
    template: require('./clearance-list.component.html'),
    styles: [`
        .tag-list.hoverable:hover > div {
            filter: brightness(95%);
        }
        .tag-list.hoverable {
            border-radius: 20px;
            transition: all 200ms ease-out;
            }
        .hoverable:hover {
            box-shadow: 0 0 6px #f9a825;
        }
        .center{
            margin-top: 5px;
            margin-left: 5px;
        }
        .tv-animation-card{
            height: 240px !important;
        }
        .clear-icon-search{
            position: relative !important; 
            right: 50px !important;
        }
    `]
})
export class ClearanceListComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('tagComponent') tagComponent: ClearanceItemTagComponent;
    @ViewChild('imageAsset') imageComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('documentAsset') documentComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('maincontainer') public maincontainer: ElementRef;
    @ViewChild('bulkAction') bulkActionComponent: ClearanceItemBulkComponent;

    pageTitle: string = 'Clearance Items';
    isClearanceUser: boolean = false;
    isLoadingMoreRecords: boolean = false;
    listSearchData: ListSearchData;
    listSearchAllData: ListSearchData;
    massUpdateData: MassUpdateData = new MassUpdateData();
    itemList: ClearanceItem[] = [];
    completeitemList: ClearanceItem[] = [];
    showSpinner: boolean = false;
    statusLookup: ILookup[] = [];
    modalstatusLookup: ILookup[] = [];
    selectedItem: ClearanceItem;
    sortByLookup: ILookup[] =
        [{ id: "CreatedBy", name: 'Date Added', type: "" },
        { id: "Name", name: 'A-Z', type: "" },
        { id: "ModifiedDate", name: 'Date Modified', type: "" },
        { id: "Deadline", name: 'Deadline', type: "" },
        { id: "Status", name: 'Status', type: "" }];
    filterByLookup: ILookup[] =
        [{ id: "Keyword", name: 'Keyword', type: "" },
        { id: "Name", name: 'Name', type: "" },
        { id: "Number", name: 'Number', type: "" },
        { id: "Copyright", name: 'Copyright/Owner', type: "" },
        { id: "Artist/Author", name: 'Artist/Author', type: "" },
        { id: "Season", name: 'Season', type: "" },
        { id: "Episode", name: 'Episode', type: "" },
        { id: "ReportGroup", name: 'Report Group Name', type: "" },
        { id: "Tags", name: 'Tags', type: "" },
        { id: "Restrictions", name: 'Restrictions', type: "" }];

    //materialize-related
    modalActions = new EventEmitter<string | MaterializeAction>();
    filterMaterializeActions = new EventEmitter<string | MaterializeAction>();
    commentIsRequired: Boolean = false;
    defaultMessage: string = 'Enter criteria and hit \'Enter\' to search';
    noRecordsFoundMessage: string = 'No items found with the provided filters.';
    searchMessage: string = '';
    bulkDataList: Array<Object> = new Array<Object>();
    inErrorState: boolean = false;
    readonly maxDisplayedTags: number = 3;

    private routeScrollPositions: { [url: string]: number }[] = [];
    private subscriptions: Subscription[] = [];
    private wasPop: boolean = false;
    private previousNavigationUrl: string;

    carouselImages = [];
    public dataImages = [];
    showCarousel: boolean = false;
    currentCarouselIndex = 0;
    currentCarouselCiName: string;
    currentCiStatus: string;
    clearanceItem: ClearanceItem = new ClearanceItem();
    projectDepartment: string = "";

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _clearanceItemService: ClearanceItemService,
        private _appService: AppService,
        private _authService: AuthService,
        private _notificationsService: NotificationsService,
        private _messageBrokerService: MessageBrokerService,
        private location: Location,
        private fb: FormBuilder,
        private _reportService: ReportsService,
        private modalService: ModalService,
        private _errorHandler: GlobalErrorHandler,
        private _locStrat: LocationStrategy,
        platLocation: PlatformLocation,
        private _projectService: ProjectService,

    ) {
        this.searchMessage = this.defaultMessage;
        this.subscribeToChanges();
        this.setupAutoScrolling(platLocation);
    }

    subscribeToChanges() {

        this._messageBrokerService.subscribeToItemChanged().subscribe(i => {
            this.getClearanceItem(i.id);
        });

        this._messageBrokerService.subscribeToItemDeleted().subscribe(id => {
            let index = this.itemList.findIndex(i => i.id == id);
            if (index >= 0) {
                this.itemList.splice(index, 1);
            }
        });
    }

    setupAutoScrolling(platLocation: PlatformLocation) {

        platLocation.onPopState(() => {
            this.wasPop = true;
        });

        let self = this;

        this.subscriptions.push(
            self._router.events.subscribe((e) => {

                if ((e instanceof NavigationStart) && self.selectedItemId) {

                    if (!self.isLinkActive('/projects'))
                        return;

                    let index = self.previousNavigationUrl !== null ? self.previousNavigationUrl : e.url;
                    self.routeScrollPositions[index] = window.pageYOffset;
                } else if (e instanceof NavigationEnd) {
                    if (!self._router.isActive('projects', false)) {
                        window.scrollTo(0, 0);
                        self.wasPop = false;
                        return;
                    }
                    self.previousNavigationUrl = e.url;
                    if (self.wasPop) {
                        if (!self.routeScrollPositions[e.url]) {
                            window.scrollTo(0, 0);
                            self.wasPop = false;
                            return;
                        }
                        setTimeout(() => {
                            window.scrollTo(0, self.routeScrollPositions[e.url] || 0);
                            // self._notificationsService.add(new Notification('info', 'window scroll for :\'' + e.url + '\' to:' + self.routeScrollPositions[e.url]));
                        }, 1000);
                        self.wasPop = false;

                    } else {
                        window.scrollTo(0, 0);
                    }
                };
            })
        );
    }

    public isLinkActive(url) {
        
        let charPos = this._router.url.indexOf('?');
        let cleanUrl = charPos !== -1 ? this._router.url.slice(0, charPos) : this._router.url;
        let itemsInUrl = cleanUrl.split('/');
        if (itemsInUrl.length == 4) {
            if (itemsInUrl[1] == 'projects' && itemsInUrl[3] == 'items')
                return true;
        }
        return false;
        // return (cleanUrl === url);
    }


    getClearanceItem(id: string): void {
        
        this.showSpinner = true;
        this._clearanceItemService.getCI(id)
            .subscribe
            (
                (data) => {
                    this.onCIRetrieved(data);
                    this.selectedItemId = null;
                    this.showSpinner = false;
                },
            );
    }

    onCIRetrieved(data: ClearanceItem) {
        let item = this.itemList.findIndex(i => i.id == data.id);
        this.checkDefaultImage(data);
        if (item < 0)
            this.itemList.push(data);
        else
            this.itemList[item] = data;
    }

    ngOnInit(): void {

        this.isClearanceUser = this._authService.isUserInRole(process.env.CLEARANCE_ROLE);// || process.env.ENV == 'development';
        if (!this.isClearanceUser) {
            var indexFilter = this.filterByLookup.findIndex(it => it.id == "ReportGroup");
            this.filterByLookup.splice(indexFilter, 1);
        }
        this.listSearchData = new ListSearchData();
        this.massUpdateData = new MassUpdateData();
        this.selectedItem = new ClearanceItem(); 
        // // Read the clearance Id from the route parameter
        var obsComb = Observable.combineLatest(this._route.params, this._route.queryParams,
            (params, qparams) => ({ params, qparams }));

        obsComb.subscribe(
            combine => {
                let projectId = combine.params['projectId'];               
                let projectName = combine.qparams['projectName'];
                if (projectId) {
                    this.loadCILookups(projectId);
                    this.setProjectDepartment(projectId);                    
                    if (projectName) {
                        this._messageBrokerService.setCurrentProject(new ProjectItem(projectId, projectName), true);
                    }
                    this.listSearchData.projectId = projectId;
                    this.listSearchData.sortOrder = 'DESC';
                    let statusParam = combine.qparams['status'];
                    if (statusParam)
                        this.listSearchData.status = statusParam;
                    let sortByParam = combine.qparams['sortBy'];
                    if (sortByParam)
                        this.listSearchData.sortBy = sortByParam;
                    let sortOrder = combine.qparams['sortOrder'];
                    if (sortOrder)
                        this.listSearchData.sortOrder = sortOrder;
                    if (sortOrder == 'DESC') {
                        this.sortOrderIcon = 'arrow_downward';
                        this.sortOrderTooltip = 'sort asc';
                    }
                    else if (sortOrder == 'ASC') {
                        this.sortOrderIcon = 'arrow_upward';
                        this.sortOrderTooltip = 'sort desc';
                    }

                    let filterBy = combine.qparams['filterBy'];
                    if (filterBy)
                        this.listSearchData.filterBy = filterBy;
                    let filterString = combine.qparams['filterString'];
                    if (filterString)
                        this.listSearchData.filterString = filterString;

                    this.filterChanged('onLoad');
                }
            }
        );

        this._appService.scrollBottomReachedEvent.subscribe(()=>{
            this.loadMoreRecords();
        })
        this.loadAllRecords();
    }

    ngOnDestroy(): void {
        console.log('ngOnDestroy()');
    }

    ngAfterViewInit(): void {        
        SharedUtils.RemoveTooltipIfNeeded('#more_titles_tooltip');
        Materialize.updateTextFields();

        if (SharedUtils.IsMobile()) {

            this.openFirst();
            setTimeout(() => {
                this.closeFirst();
            }, 1500);
        }
        SharedUtils.FixFlickering();
    }
    setStatusClasses(item) {
        let cssClasses =
        {
            'not-clear': item.status == 'NOT CLEAR',
            'clear': (item.status && item.status.includes('CLEAR') && item.status != 'NOT CLEAR' && item.status != 'PERMISSIBLE - Graphics Require Review') || item.status=='PERMISSIBLE' || item.status == 'PERMISSIBLE - Background Use Only',
            'new': item.status == 'NEW',
            'abandoned': item.status == 'ABANDONED',
            'pending': item.status && item.status == 'PERMISSIBLE - Graphics Require Review' || item.status.includes('PENDING')
        };
        return cssClasses;
    }

    openFirst() {
        this.filterMaterializeActions.emit({ action: "collapsible", params: ['open'] });
        // this.accordionActions.emit({ action: "collapsible", params: ['open', 0] });
    }

    closeFirst() {
        this.filterMaterializeActions.emit({ action: "collapsible", params: ['close'] });
    }

    get IsSearchMessageDefault(): Boolean {
        return this.searchMessage === this.defaultMessage;
    }

    sortOrderTooltip = 'sort desc';
    sortOrderIcon = 'arrow_downward';

    filterChanged(filterType: string): void {

        // console.log('sortOrderTooltip:' + this.sortOrderTooltip);
        window.scrollTo(0, 0);
        if (filterType == 'sortBy' && this.listSearchData.sortBy == "Status") {
            this.listSearchData.sortOrder = 'ASC';
            this.sortOrderIcon = 'arrow_upward';
            this.sortOrderTooltip = 'sort desc';
        }

        if (filterType == 'sortOrder') {
            if (!this.listSearchData.sortOrder || this.listSearchData.sortOrder == 'ASC') {
                this.listSearchData.sortOrder = 'DESC';
                this.sortOrderIcon = 'arrow_downward';
                this.sortOrderTooltip = 'sort asc';
            }
            else {
                this.listSearchData.sortOrder = 'ASC';
                this.sortOrderIcon = 'arrow_upward';
                this.sortOrderTooltip = 'sort desc';
            }
        }
        else if (filterType == 'clear') {
            this.listSearchData.filterBy = this.filterByLookup[0].id;
            this.listSearchData.sortBy = this.sortByLookup[0].id;
            this.listSearchData.sortOrder = null;
            this.listSearchData.filterString = null;
            this.listSearchData.status = this.statusLookup[0].id;
        }

        //Making work the new keyword criteria
        if ((this.listSearchData.filterString == undefined || this.listSearchData.filterString == null
            || this.listSearchData.filterString == '') && this.listSearchData.filterBy != undefined) {
            this.listSearchData.filterBy = null;
        } else if (this.listSearchData.filterString != undefined && this.listSearchData.filterString != null
            && this.listSearchData.filterString != '' && this.listSearchData.filterBy == undefined) {
            this.listSearchData.filterBy = this.filterByLookup[0].id;
        }

        this.listSearchData.pazesize = 10;
        this.listSearchData.pageStartIndex = 0;
        this.listSearchData.totalNumberOfRecords = 0;
        // console.log(this.listSearchData);
        this.getItemList();
        if (filterType != 'onLoad') {
            this.updateRouteURL();
        }
    }

    updateRouteURL(): void {
        if (this.listSearchData && this.listSearchData.projectId) {
            let newUrl = '/projects/' + this.listSearchData.projectId + '/items';
            if (this.listSearchData.sortBy) {
                newUrl += '?sortBy=' + this.listSearchData.sortBy;
            }
            else {
                newUrl += '?sortBy=CreatedDate';
            }
            if (this.listSearchData.sortOrder) {
                newUrl += '&sortOrder=' + this.listSearchData.sortOrder;
            }
            if (this.listSearchData.status) {
                newUrl += '&status=' + this.listSearchData.status;
            }

            if (this.listSearchData.filterBy && this.listSearchData.filterString) {
                newUrl += '&filterBy=' + this.listSearchData.filterBy;
                newUrl += '&filterString=' + this.listSearchData.filterString;
            }
            this.location.replaceState(newUrl);
            this._appService.listViewURL = newUrl;
            console.log(this._appService.listViewURL);
        }
    }
    stopPropagation(e): void {
        e.stopPropagation();
    }
    selectAllItems(e): void {
        if (this.itemList) {
            if (e.target.checked) {
                this.itemList.forEach(it => it.isSelected = true);
            }
            else {
                this.itemList.forEach(it => it.isSelected = false);
            }
        }
    }
    getItemList(): void {

        
        this.showSpinner = true;
        this.searchMessage = '';
        this.listSearchData.filterString = DateUtils.tryToFormatStringToDateFormat(this.listSearchData.filterString, 'yyyy-MM-dd');
        this.inErrorState = false;
        this._clearanceItemService.getCIList(this.listSearchData)
            .subscribe
            (
                (data) => {
                    if (!data.resultSet || data.resultSet.length == 0) {
                        this.searchMessage = this.noRecordsFoundMessage;
                    }
                    this.onListDataRetrieved(data);
                    this.showSpinner = false;
                },
                (error: any) => {
                    this.itemList = [];
                    this.selectedItemId = null;
                    this.showSpinner = false;
                    if (error.status == 404) {
                        this.searchMessage = this.noRecordsFoundMessage;
                    } else {
                        this._errorHandler.processError(error);
                    }
                    this.inErrorState = true;

                }
            );

    }

    private selectedItemId: string;
    openItemDetails(itemId: string): void {
        this.selectedItemId = itemId;
        this._router.navigateByUrl('/projects/' + this.listSearchData.projectId + '/items/' + itemId);
    }

    @HostListener("window:scroll", ["$event"])
    public onWindowScroll() {
        if (this.isBottomReached()) {
            //code when scroll reached end
            // console.log('scroll reached end');
            this.loadMoreRecords();
        }
    }


    isBottomReached(): Boolean {
        let windowHeight = "innerHeight" in window ? window.innerHeight
            : document.documentElement.offsetHeight;
        let body = document.body, html = document.documentElement;
        let docHeight = Math.max(body.scrollHeight,
            body.offsetHeight, html.clientHeight,
            html.scrollHeight, html.offsetHeight);
        let windowBottom = windowHeight + window.pageYOffset;
        if (windowBottom >= docHeight) {
            return true;
        }
        return false;
    }

    moreRecords(): boolean {
        if (!this.isLoadingMoreRecords && this.listSearchData.projectId) {
            let nextPageRecordStartIndex = this.listSearchData.pazesize + this.listSearchData.pageStartIndex;
            return this.listSearchData.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000;
        }

        return false;
    }

    manualLoad(): void {
        this.loadMoreRecords();
        setTimeout(() => {
            this.maincontainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        });
    }

    loadMoreRecords(): void {
        
        if (!this.isLoadingMoreRecords && this.listSearchData.projectId) {
            let nextPageRecordStartIndex = this.listSearchData.pazesize + this.listSearchData.pageStartIndex;
            //if there are more records to fetch
            if (this.listSearchData.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000) {
                this.isLoadingMoreRecords = true;
                this.listSearchData.pageStartIndex = nextPageRecordStartIndex;
                this.listSearchData.filterString = DateUtils.tryToFormatStringToDateFormat(this.listSearchData.filterString, 'yyyy-MM-dd');
                this.inErrorState = false;
                this._clearanceItemService.getCIList(this.listSearchData)
                    .subscribe
                    (
                        (data) => {
                            this.isLoadingMoreRecords = false;
                            if (data.resultSet) {
                                this.listSearchData.totalNumberOfRecords = data.totalNumberOfRecords;
                                this.listSearchData.pageStartIndex = data.pageStartIndex;
                                data.resultSet.forEach(it => {
                                    it.deadline = DateUtils.toDateFromString(it.deadline, 0, 1, 2, 'MM-dd-yyyy', '-');
                                    this.itemList.push(this.checkDefaultImage(it));
                                });

                                console.log(this.itemList.length);
                            }

                        },
                        (error: any) => {
                            this.isLoadingMoreRecords = false;
                            this.itemList = [];
                            this.selectedItemId = null;
                            if (error.status == 404) {

                            } else {
                                this._errorHandler.processError(error);
                            }
                            this.inErrorState = true;
                        }
                    );
            }

        }
    }
    onListDataRetrieved(listSearchData: ListSearchData): void {
        
        console.log(listSearchData);
        this.itemList = [];
        this.selectedItemId = null;
        if (listSearchData.resultSet) {
            listSearchData.resultSet.forEach(item => {
                item.deadline = DateUtils.toDateFromString(item.deadline, 0, 1, 2, 'MM-dd-yyyy', '-'),
                    this.itemList.push(this.checkDefaultImage(item));
            });

            this.listSearchData.totalNumberOfRecords = listSearchData.totalNumberOfRecords;
            this.listSearchData.pageStartIndex = listSearchData.pageStartIndex;

            if (listSearchData.totalNumberOfRecords > 0) { this.selectedItem = listSearchData.resultSet[0]; }
        }
    }

    showAllTags(item: ClearanceItem): void {
        // if (itemSelectedName != '...') {
        //     this.openItemDetails(item.id);
        // } else {
        this.selectedItem = item;
        $('#modal-all-tags').modal('open');
        // }
    }

    checkDefaultImage(item: ClearanceItem): ClearanceItem {
        if (item) {
            
            if (item.images && item.images.length > 0) {
                //determine default image
                let imagesOnly = item.images.filter(i => i.assetType.toLowerCase() === 'image' &&  SharedUtils.FileTypeIsImage(i.fileType));
                let attachments = item.images.filter(i => i.assetType.toLowerCase() === 'image');
                item.defaultImage = imagesOnly.find(i => i.defaultC == true);
                if (!item.defaultImage && imagesOnly.length > 0)
                    item.defaultImage = imagesOnly[0];
                else {
                    item.defaultImage = attachments[0];
                    if (item.defaultImage.fileType.endsWith('pdf'))
                        item.defaultImage.fullUrl = '../../assets/images/PDF_file_icon.png';
                    else if (!SharedUtils.FileTypeIsImage(item.defaultImage.fileType)) 
                        item.defaultImage.fullUrl = '../../assets/images/attachment-icon.jpg';
                }
            }
            else {
                //add default image
                item.images = [];
                let image = new CIImage();
                // image.fullUrl='https://s3.amazonaws.com/uifaces/faces/twitter/brad_frost/128.jpg';
                item.images.push(image);
            }
        }
        return item;
    }

    loadFinished(img) {
        $('.list-thumbnail').addClass('animated flipInX');
    }
    loadCILookups(projectId :string): void {
        
        this._appService.retrieveCILookups(undefined, projectId)
            .subscribe(
                (list) => {
                    if (list) {
                        this.onLookupsRetrieved(list);
                    }
                },
                (error) => {
                    this._errorHandler.processError(error);
                }
            );

    }
    onLookupsRetrieved(list: LookupList[]): void {
        
        if (list && list.length > 0) {
            this.statusLookup = [];
            if (list.find(it => it.lookupType == 'CIStatus') != null && list.find(it => it.lookupType == 'CIStatus').lookupData) {
                this.modalstatusLookup = list.find(it => it.lookupType == 'CIStatus').lookupData;
                list.find(it => it.lookupType == 'CIStatus').lookupData.forEach(look => this.statusLookup.push(look));
                let staticLookup = new ILookup('Urgent', 'Urgent');
                this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                staticLookup = new ILookup('All', 'All');
                this.statusLookup.splice(0, 0, staticLookup);
                staticLookup = new ILookup('All Pending', 'All Pending');
                this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                staticLookup = new ILookup('All Clear', 'All Clear');
                this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);

            }
        }

    }

    /// The below is not part of the bulk action item
    initializeAllTagModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            // this.bulkDataList = this.tag;
            this.massUpdateData.updateType = 'AddTags';
            this.massUpdateData.tags = [];
            this.tagComponent.loadTagLookups();
            $('#modal-all-tags').modal('open');
        }

    }

    onModalInitRequest(modalId: string) {
        if (modalId === 'modal-status') {
            this.initializeStatusModal();
        } else if (modalId === 'modal-groupName') {
            this.initializeGroupNameModal();
        } else if (modalId === 'modal-tag') {
            this.initializeTagModal();
        } else if (modalId === 'modal-release') {
            this.initializeDocModal();
        } else if (modalId === 'modal-image') {
            this.initializeImageModal();
        } else {
            console.error('Did not understand the modal Id request:' + modalId);
        }
    }

    initializeStatusModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = this.modalstatusLookup;
            this.currentBulkModalId = 'modal-status';
            this.bulkActionComponent.setForm(this.initStatusForm());
            this.bulkActionComponent.initializeModal('modal-status', this.changeStatus.bind(this));
        }
    }

    initStatusForm(): FormGroup {
        let f = this.fb.group(
            {
                status: 'NEW',
                comments: ''
            });

        f.controls.status.valueChanges.subscribe(v => {
            if (v === 'PENDING - Production Info Required' || v === 'PENDING - Modifications Required') {
                f.controls.comments.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(255)]);
            } else {
                f.controls.comments.clearValidators();
            }
        });

        return f;
    }

    currentBulkModalId = '';
    initializeGroupNameModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkActionComponent.initializeModal('modal-groupName', this.updateGroupName.bind(this));
        }
    }

    initializeTagModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = [];
            this.bulkActionComponent.initializeModal('modal-tag', this.addTags.bind(this));
        }

    }

    initializeImageModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = [];
            this.bulkActionComponent.initializeModal('modal-image', this.addImages.bind(this));
        }

    }

    initializeDocModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = [];
            this.bulkActionComponent.initializeModal('modal-release', this.addDocuments.bind(this));
        }

    }

    generateReport(): void {
        var reportGenerateParams = this.getRequestParams();
        this._reportService.generateReports(reportGenerateParams)
            .subscribe(
                (res) => {
                    console.log('queued: ' + res);
                    this._notificationsService.add(new Notification('success', 'Your report has been submitted for processing, please check the Reports page.'));
                    this.showSpinner = false;
                },
                (error: any) => {
                    var e = JSON.stringify(error);
                    if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
                    }else{
                        this._errorHandler.processError(error);
                    }
                }
            );
    }

    getRequestParams(): ReportBuilder {
        var retValue = new ReportBuilder();
        retValue.searchBy = this.listSearchData.filterBy;
        retValue.searchByValue = DateUtils.tryToFormatStringToDateFormat(this.listSearchData.filterString, 'yyyy-MM-dd');
        retValue.projectId = this.listSearchData.projectId;
        retValue.sortedBy = this.listSearchData.sortBy;
        retValue.sortDirection = this.listSearchData.sortOrder;
        if (this.listSearchData.status) {
            retValue.status = this.listSearchData.status;
        }
        else {
            retValue.status = 'All';
        }
        if (this.anyItemSelected()){
            retValue.selectedIDs = this.getSelectedCIIds();
        }
        retValue.reportName = 'cilistreport';
        retValue.reports = [];
        return retValue;
    }


    showFilters(e): void {
        this.filterMaterializeActions.emit({ action: "collapsible", params: ['open', 0] });
        if (e) {
            console.log('e:' + JSON.stringify(e))
            e.stopPropagation();
        }

    }

    addTags(selectedTags: CITag[]): void {
        
        if (selectedTags && selectedTags.length > 0 && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'AddTags';
            this.massUpdateData.tags = [];

            this.massUpdateData.tags = selectedTags;
            this.massUpdateData.clearanceItems = [];
            this.itemList.forEach(it => {
                if (it.isSelected)
                    this.massUpdateData.clearanceItems.push(it.id)
            });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            $('#modal-tag').modal('close');
                            this._notificationsService.add(new Notification('success', 'Selected Items are updated with tags '));
                            this.filterChanged('onLoad');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }
    createNewItem(): void {
        //$('.tooltipped').tooltip('remove');
         $('.material-tooltip').remove();
        //$('.material-tooltip').css("visibility", "hidden");
        this._router.navigate(['projects', this.listSearchData.projectId, 'items', 'new']);
      }
    addImages(selectedImages: CIAsset[]): void {
        
        if (selectedImages && selectedImages.length > 0 && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'AddImages';
            this.massUpdateData.images = [];
            this.massUpdateData.documents = [];

            selectedImages.forEach(it => {
                it.fullUrl = '';
                it.defaultC = false;
                it.assetType = 'Image';
            });
            this.massUpdateData.images = selectedImages;
            this.massUpdateData.clearanceItems = [];
            this.massUpdateData.projectId = this.listSearchData.projectId;
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            $('#modal-image').modal('close');
                            this._notificationsService.add(new Notification('success', 'Selected images are added to selected items '));
                            this.filterChanged('onLoad');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }
    addDocuments(selectedDocs: CIAsset[]): void {
        
        if (selectedDocs && selectedDocs.length > 0 && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'AddDocuments';
            this.massUpdateData.images = [];
            this.massUpdateData.documents = <CIDocument[]>selectedDocs;
            this.massUpdateData.clearanceItems = [];
            this.massUpdateData.projectId = this.listSearchData.projectId;
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            $('#modal-release').modal('close');
                            this._notificationsService.add(new Notification('success', 'Selected documents are added to selected items '));
                            this.filterChanged('onLoad');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }

    changeStatus(status: FormGroup) {
        
        console.log(this.massUpdateData);
        if (this.massUpdateData.status != 'All' && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'ChangeStatus';
            this.massUpdateData.statusChangeComments = status.value.comments;
            this.massUpdateData.status = status.value.status;

            this.massUpdateData.clearanceItems = [];
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected Items are updated with status ' + this.massUpdateData.status));
                            this.filterChanged('onLoad');
                            this._messageBrokerService.sendMessageToRefreshLeftNav('');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }

    updateGroupName(groupName: FormGroup): void {
        
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'GroupName';
            this.massUpdateData.groupName = groupName.value.reportGroupName;

            this.massUpdateData.clearanceItems = [];
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe(
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected Items were updated with Group Name \'' + this.massUpdateData.groupName + '\''));
                            this.filterChanged('onLoad');
                            this._messageBrokerService.sendMessageToRefreshLeftNav('');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        // this._errorHandler.processError(error);
                    }
                );
        }
    }

    anyItemSelected(): boolean {
        let isSelected = this.itemList && this.itemList.filter(it => it.isSelected).length > 0;
        return isSelected;
    }

    get allItemsSelected(): boolean {
        let ret = this.itemList.filter(i => i.isSelected === true).length === this.itemList.length;
        // console.log('ret: ' + ret);
        return ret && this.itemList.length > 0;
    }

    tagsString(item: ClearanceItem): string {
        if (item.tags)
            return item.tags.map(t => t.tagName).join(',');
        return '';
    }

    stringTitle(item): string {
        return item.titles.filter(t => !!!t.isDefault && item.name != t.name) .map(t => t.name).join(', ');
    }

    getSelectedCIIds(): string{
        return "##" + this.itemList.filter(it => it.isSelected).map(item => item.id).join("##") + "##";
    }

    moreTitlesVisible(item: ClearanceItem){
        if (item.titles && item.titles.length>0){
            return item.titles.filter(t => !!!t.isDefault && item.name != t.name).length > 0
        }
    }

    openCarousel(item: ClearanceItem){
        if (this.modalService.modalExists('image-modal-carousel')){
            this.modalService.remove('image-modal-carousel');
        }
        var parent = this;
        this.showSpinner = true;
        Observable.forkJoin(this._clearanceItemService.getCI(item.id, true))
            .subscribe
            (
                (data) => {
                    parent.onSingleCIRetrieved(data[0]);
                    parent.showSpinner = false;
                    if (!parent.carouselImages || parent.carouselImages.length==0){
                        this._notificationsService.add(new Notification('warn', 'This Clearance Item has no images to show','',false));
                        return;
                    }
                    var default_index = parent.carouselImages.findIndex(img => img.url == item.images[0].url);
                    parent.currentCarouselIndex = default_index;
                    parent.showCarousel = this.carouselImages ? true : false;
                    if (this.modalService.modalExists('image-modal-carousel')){
                        parent.modalService.open('image-modal-carousel');
                    }
                },
            );
    }

    onSingleCIRetrieved(ci: ClearanceItem): void {
        if (ci) {
            this.clearanceItem = ci;
            this.currentCarouselCiName = ci.name;
            this.currentCiStatus = ci.status;
            this.carouselImages = [];
            if (this.clearanceItem && this.clearanceItem.images && this.clearanceItem.images.length > 0) {
                this.clearanceItem.images.forEach(img => {
                    if (img.assetType=="Image"){
                        img.originalImageFullUrl = img.fullUrl;
                        this.carouselImages.push(img);
                    }
                });
            }
        }
    }

    closeCarousel($event){
        this.showCarousel = false;
    }

    setProjectDepartment(projectId: string): void {
        this._projectService.getProject(projectId)
            .subscribe((project: IProject) => {
                this.projectDepartment = project.department;
            },
                (error: any) => {
                    this._errorHandler.processError(error);
                }
            );
    }

    loadAllRecords(): void {
        this.listSearchAllData = {...this.listSearchData}
        this.listSearchAllData.allRecords = true;
        this._clearanceItemService.getCIList(this.listSearchAllData)
            .subscribe
            (
                (data) => {
                    if (data.resultSet) {
                        data.resultSet.forEach(it => {
                            this.completeitemList.push(this.checkDefaultImage(it));
                        });
                    }
                },
                (error: any) => {
                    this.completeitemList = [];
                    if (error.status == 404) {

                    } else {
                        this._errorHandler.processError(error);
                    }
                }
            );
     
    }

    ciStatusChange($event){
        var ci = this.itemList.find(ci => ci.id == $event.ciId);
        if (ci){
            ci.status = $event.ciStatus;
        }
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-list.component.ts